import {Appointments} from '@drl/shared/models';

import {SideEffectLogs} from './side-effect-logs.model';
import {TableData} from './table-data.model';
import {MedicineLog} from './medicine-log.model';

export class SideEffectData extends TableData {
  allSideEffects: SideEffectLogs[];
  appointments: Appointments[];
  medicineLogs: MedicineLog[];
  cellBgndClass?: {[id: number]: string};
}
